export class ForgotPasswordRequest {
	constructor(email: string) {
		this.email = email;
	}
	
	email: string;
}